module.exports = __webpack_public_path__ + "img/life-page4-img-1.db7960e9.jpg";